import React, { useEffect } from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';
import Carousel from 'nuka-carousel';

const StyledVideo = styled.div`
	section {
		text-align: center;
		background-image: url(${(p) => p.bimg});
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}
	.slider {
		width: 70%;
		margin: 2rem auto 0;

		.slider-control-centerright {
			right: -1.5rem !important;
			img {
				width: 1rem;
			}
		}
		.slider-control-centerleft {
			left: -1.5rem !important;
			img {
				width: 1rem;
			}
		}
		.slider-slide .image img {
			margin: 0 auto;
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
			border: #fff solid 0.5rem;
		}
	}
`;

export default ({ data }) => {
	const { top, title, bimg, images } = data;

	useEffect(() => {
		// hacky carousel fix
		setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);
	});

	return (
		<StyledVideo bimg={bimg}>
			<Section>
				<Top color="green">{top}</Top>
				<h2>{title}</h2>
				<div className="slider">
					<Carousel
						wrapAround={true}
						renderBottomCenterControls={null}
						renderCenterLeftControls={({ previousSlide }) => (
							<button aria-label="previous slide" onClick={previousSlide}>
								<img src="/img/chevron-left-white.svg" alt="chevron left" />
							</button>
						)}
						renderCenterRightControls={({ nextSlide }) => (
							<button aria-label="next slide" onClick={nextSlide}>
								<img src="/img/chevron-right-white.svg" alt="chevron right" />
							</button>
						)}
					>
						{images.map((x, i) => (
							<div className="image" key={i}>
								<img src={x.src} alt={x.alt} />
							</div>
						))}
					</Carousel>
				</div>
			</Section>
		</StyledVideo>
	);
};
